var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeRejectedVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23114_8086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6984 9.52009L10.2558 9.07757C9.9304 8.75214 9.40277 8.75214 9.07733 9.07757C8.75189 9.40301 8.75189 9.93065 9.07733 10.2561L10.9982 12.177C9.83848 12.2819 8.83325 13.1931 8.83325 14.4287V21.5716C8.83325 22.8862 9.97102 23.8335 11.2221 23.8335H19.7777C20.5461 23.8335 21.2717 23.4762 21.7172 22.896L25.744 26.9228C26.0694 27.2482 26.5971 27.2482 26.9225 26.9228C27.2367 26.6086 27.2476 26.106 26.9552 25.7788L10.731 9.55459C10.7197 9.54332 10.7088 9.53182 10.6984 9.52009Z",
    fill: "#FF3A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9546 22.4212C26.1024 22.3793 26.2442 22.317 26.3759 22.2356C26.6175 22.0864 26.817 21.8778 26.9553 21.6298C27.0937 21.3819 27.1664 21.1026 27.1666 20.8186V15.1815C27.1664 14.8975 27.0937 14.6179 26.9553 14.3699C26.817 14.1219 26.6175 13.9133 26.3759 13.7641C26.1343 13.6148 25.8586 13.5298 25.5749 13.517C25.2912 13.5042 25.009 13.5641 24.7549 13.6911L22.1666 14.985V14.4287C22.1666 13.1141 21.0288 12.1668 19.7777 12.1668H15.7002L25.9546 22.4212Z",
    fill: "#FF3A5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23114_8086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeRejectedVideoCall);
export default __webpack_public_path__ + "static/media/me-rejected-video-call.55a5aa3fb0237dcc470fec9345efa7a7.svg";
export { ForwardRef as ReactComponent };